import { USER_AUTHENTICATED, USER_LOG_OUT } from "../actions/user";

const initState = {
    identity: null,
    expires: null,
    authToken: null
}

export default function userReducer(user=initState, action) {
    switch(action.type)
    {
        case USER_AUTHENTICATED:
            return {
                ...user,
                authToken: action.authToken,
                identity: action.identity,
                expires: action.expires,
                caps: action.caps
            };
        case USER_LOG_OUT:
            return {...initState};
        default:
            break;
    }

    return user;
}
